import { Player } from '../types/game';

export interface TurnStatsContext {
  previousScore: number;
  newScore: number;
  baseDelta: number;
  isPass: boolean;
}

/**
 * Updates player statistics for a completed turn.
 */
export function applyTurnStats(player: Player, ctx: TurnStatsContext): Player {
  const delta = ctx.newScore - ctx.previousScore;
  const stats = { ...player.statistics };
  stats.totalTurns += 1;
  if (ctx.isPass) stats.totalPasses += 1;
  if (delta < 0) stats.totalNegativePoints += Math.abs(delta);
  stats.totalPointsDelta = (stats.totalPointsDelta || 0) + delta;
  stats.averageScore = stats.totalTurns > 0 ? stats.totalPointsDelta / stats.totalTurns : 0;
  return { ...player, statistics: stats };
}

/**
 * Reverts a previously applied score delta from player statistics.
 */
export function revertScoreDelta(player: Player, delta: number, undoTurn: boolean): Player {
  const stats = { ...player.statistics };
  stats.totalPointsDelta -= delta;
  if (delta < 0) {
    stats.totalNegativePoints = Math.max(0, stats.totalNegativePoints - Math.abs(delta));
  }
  if (undoTurn) {
    stats.totalTurns = Math.max(0, stats.totalTurns - 1);
  }
  stats.averageScore = stats.totalTurns > 0 ? stats.totalPointsDelta / stats.totalTurns : 0;
  return { ...player, statistics: stats };
}
